import { Component, Input } from '@angular/core';
import { CategoriaAttualeService } from 'src/app/shared/services/custom/categoria-attuale.service';
import { StoreService } from '../../shared/services/store.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    @Input() layout: 'classic'|'compact' = 'classic';

    logo;

    iconeEnabled = true;

    constructor(public store: StoreService, private classificazioni : CategoriaAttualeService) {
        if (this.store.logo) {
            fetch(this.store.logo).then(response => {
                this.logo = this.store.logo;
            });
        }


        this.iconeEnabled = true;
    }
}
